import { getListingPhotoIssueDefinitions } from "@/lib/listingPhotoFeedback";

/**
 * Listing issue types that can be selected when requesting improvements
 */
export interface ListingIssue {
  id: string;
  label: string;
  description: string;
  messageText: string; // Specific message text for this issue
}

/** Active needs-action presets. Specific photo notes are typed by the admin. */
export const LISTING_ISSUES: ListingIssue[] = [
  ...getListingPhotoIssueDefinitions().filter(
    (issue) => issue.id === "image_quality",
  ),
  {
    id: "pricing_issues",
    label: "Price",
    description: "Applies to the asking price.",
    messageText:
      "* Price — For a used item, start around 60–65% of what you paid. If you paid ₦100,000, try about ₦62,000–₦65,000, then adjust for wear. This is a guide.",
  },
];

/** Labels for presets no longer offered on new reviews. */
const RETIRED_LISTING_ISSUE_LABELS: Record<string, string> = {
  non_descriptive_title: "Title",
  description_unacceptable: "Description",
  image_quality_main: "Photo 1 (cover)",
  image_quality_photo_2: "Photo 2",
  image_quality_photo_3: "Photo 3",
  missing_information: "Missing details",
  category_mismatch: "Category",
};

export function listingIssueLabel(slug: string): string {
  return (
    LISTING_ISSUES.find((issue) => issue.id === slug)?.label ??
    RETIRED_LISTING_ISSUE_LABELS[slug] ??
    slug
  );
}
